import { z } from 'zod';

export const BusinessAreaSchema = z.object({
  organizationId: z.coerce
    .number({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  companyId: z.coerce
    .number({ required_error: 'error_field_required' })
    .min(1, { message: 'error_field_required' }),
  businessAreaName: z
    .string()
    .min(1, { message: 'error_field_required' })
    .max(255, {
      message: `error.field_max_lengh_255`,
    }),
  businessAreaCode: z
    .string()
    .min(1, { message: 'error_field_required' })
    .max(255, {
      message: `error.field_max_lengh_255`,
    }),
  parentBusinessAreaId: z.coerce.number().optional(),
});

export type FormBusinessAreaSchemaType = z.infer<typeof BusinessAreaSchema>;

export interface BusinessAreaSchemaType extends FormBusinessAreaSchemaType {
  id?: number;
}
